import { Cartesian2, Cartesian3 } from "cesium";
import { EarthBrainViewerAPIs } from "./EarthBrainViewerAPIs";
export class FlatGroundAPIs extends EarthBrainViewerAPIs {
    //FlatGround
    async pickFlatGroundEntities(x, y) {
        return await this._scDesign.pickFlatGroundEntities(new Cartesian2(x, y));
    }
    /**
     * API used to zoom in to the flat ground attached with flatGroundId
     * @param flatGroundId
     */
    fitToFlatGround(flatGroundId) {
        this._scDesign.fitToFlatGround(flatGroundId);
    }
    /**
     * Enables the flat ground creation mode when status is set to true and disbale the mode when status is set to false
     * @param status
     * @param callback (flatGroundID) => {console.log(flatGroundID)}
     */
    enablePolygonCreation(callback, associatedTerrain, associatedRubbingDestination) {
        this._scDesign.enableFlatGroundCreation(callback, associatedTerrain, associatedRubbingDestination);
    }
    /**
     * Removes the flat ground from the viewer if present
     * @param polygonID
     */
    removePolygon(polygonID) {
        this._scDesign.removeFlatground(polygonID);
    }
    /**
     * Function returns Control point coordinates
     * @param flatGroundID Flat ground ID
     * @param flatGroundPointID Flat ground Control point ID whose coordinates we require
     * @returns Cesium.Cartesian3 values of control point
     */
    getCtrlPointCordiOnFlatGround(flatGroundID, flatGroundPointID) {
        return this._scDesign.getCtrlPointCordiOnFlatGround(flatGroundID, flatGroundPointID);
    }
    /**
     * Function to updates coordinates values of control points
     * @param flatGroundID Flat ground ID
     * @param flatGroundPointID Flat ground Control point ID whose coordinates we will update
     * @param x by this x value we need to update control point value
     * @param y by this y value we need to update control point value
     * @param z by this z value we need to update control point value
     */
    async updateCtrlPointCordiOnFlatGround(flatGroundID, flatGroundPointID, x, y, z) {
        await this._scDesign.updateCtrlPointCordiOnFlatGround(flatGroundID, flatGroundPointID, new Cartesian3(x, y, z));
    }
    /**
     * Enables the flat ground point drag mode when status is set true and disables it when status is set to false
     * @param status
     * @param flatGroundID
     */
    enableFlatGroundEdit(status, flatGroundID, callback) {
        this._scDesign.enableFlatGroundEdit(status, flatGroundID, callback);
    }
    /**
     * Removes the point from flat ground area
     * @param flatGroundID
     * @param flatGroundPointID
     */
    removePointFromFlatGround(flatGroundID, flatGroundPointID) {
        this._scDesign.removePointFromFlatGround(flatGroundID, flatGroundPointID);
    }
    /**
     * This Fucntion will add a new reference point in mid when left click on previewed midpoints.
     * @param flatGroundID Flat Ground ID on which function should be called
     */
    // public addMidPointsForFlatGround(flatGroundID: string, callback: (id: string) => void) {
    //   this._scDesign.addMidPointsForFlatGround(flatGroundID, (id) => {
    //     callback(id);
    //   });
    // }
    addFlatGroundControlPointOnOutline(flatGroundId, posOnOutline) {
        this._scDesign.addFlatGroundControlPointOnOutline(flatGroundId, new Cartesian3(posOnOutline.x, posOnOutline.y, posOnOutline.z));
    }
    /**
     * Used to drag Flat Ground Point vertically by dragging the arrow show when called this function
     * Or by double clicking on arrows to enter desiare value
     * @param status True/False
     * @param flatGroundID Flat Ground ID for which this function is to call.
     */
    setFlatGroundPointToVerticalDrag(flatGroundID) {
        this._scDesign.setFlatGroundPointToVerticalDrag(flatGroundID);
    }
    /**
     * Start point for creation of flatground center arrow entity
     * @param status Controls the flatground ceneter arrow creation
     * @param flatGroundID
     */
    setFlatGroundToUniformVerticalDrag(flatGroundID) {
        this._scDesign.setFlatGroundToUniformVerticalDrag(flatGroundID);
    }
    setFlatGroundPointToHorizontalDrag(flatGroundID) {
        this._scDesign.setFlatGroundPointToHorizontalDrag(flatGroundID);
    }
    async updateFlatGroundSettings(flatGroundID, settings) {
        await this._scDesign.updateFlatGroundSettings(flatGroundID, settings);
    }
    async updateFlatGroundMaterialSettings(flatGroundID, commonMaterial, embankmentMaterial, cutMaterial) {
        await this._scDesign.updateFlatGroundMaterialSettings(flatGroundID, commonMaterial, embankmentMaterial, cutMaterial);
    }
    /**
     * Updates the visibility of the Flat Ground related to provided flatGroundID
     * @param flatGroundID
     * @param show
     */
    async restoreFlatGroundAfterHiding(flatGroundID) {
        await this._scDesign.restoreFlatGroundAfterHiding(flatGroundID);
    }
    toggleFlatGroundVisibility(flatGroundID, show) {
        this._scDesign.toggleFlatGroundVisibility(flatGroundID, show);
    }
    /**
     * Export the flatGround's LandXML file
     * @param flatGroundID
     */
    getFlatGroundMeshGeometry(flatGroundID) {
        return this._scDesign.getFlatGroundMeshGeometry(flatGroundID);
    }
    /**
     * Saves flat ground object as JSON string and return that string
     * @param id
     * @returns
     */
    getFlatGroundJSON(id) {
        return this._scDesign.getFlatGroundJSON(id);
    }
    /**
     * Creates flat ground using json string and return flat ground id
     * @param jsonString
     * @returns
     */
    loadFlatGroundArea(data, updateInListCallback) {
        return this._scDesign.loadFlatGroundArea(data, updateInListCallback);
    }
    /**
     * This Function will Disable Flat Ground Creation.
     * @param flatGround Pass a parameter of type 'EarthBrainFlatGround' to this function to disable Flat Ground creation.
     */
    // public disableFlatGroundCreation(flatGround: FlatGround) {
    //     this._scDesign.disableFlatGroundCreation(flatGround);
    // }
    /**
     * This Function will check whether there is any Flat Ground under creation.
     * @returns True or False for Flat Ground under creation or not.
     */
    checkFlatGroundUnderCreation() {
        return this._scDesign.checkFlatGroundUnderCreation();
    }
    /**
     * This Function will Disable Flat Ground Creation.
     */
    disableFlatGroundCreationHandler() {
        this._scDesign.disableFlatGroundCreationHandler();
    }
    async setFlatGroundPointsUniformHeight(id, height) {
        await this._scDesign.setFlatGroundPointsUniformHeight(id, height);
    }
    cancelFlatGroundCreation() {
        this._scDesign.cancelFlatGroundCreation();
    }
    /**
     * This function will calculate volume of Flat Ground
     * @param flatGroundID ID of Flat Ground whose volume to calculate
     * @param cellX Optional as considered unit grid size 0.5 as required unit area for grid is 0.25 sq.m
     * @param cellY Optional as considered unit grid size 0.5 as required unit area for grid is 0.25 sq.m
     * @param cellZ Optional as considered unit grid size 0.5 as required unit area for grid is 0.25 sq.m
     * @returns Fill and Cut Volume in cu. meter.
     */
    async volumeCalculationForFlatGround(flatGroundID) {
        return await this._scDesign.volumeCalculationForFlatGround(flatGroundID);
    }
    async updateTerrainAssociatedWithFlatGround(flatGroundId, terrainId, terrainType) {
        await this._scDesign.updateTerrainAssociatedWithObject(flatGroundId, "flat-ground", terrainId, terrainType);
    }
    async updateRubbingDestinationAssociatedWithFlatGround(flatGroundId, rubbingDestination) {
        await this._scDesign.updateRubbingDestinationAssociatedWithObject(flatGroundId, "flat-ground", rubbingDestination);
    }
    calculateSurfaceAreaOfFlatGround(flatGroundID) {
        return this._scDesign.calculateSurfaceAreaOfFlatGround(flatGroundID);
    }
    getMaxHeightOfFlatGroundCtrlPts(flatGroundID) {
        return this._scDesign.getMaxHeightOfFlatGroundCtrlPts(flatGroundID);
    }
}
//# sourceMappingURL=flat-ground.js.map